import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { GestionModeReglComponent } from './../../../../core/gestion-referentiel/gestion-mode-regl/gestion-mode-regl.component';
import { ModeReglService } from 'src/app/shared/services/simple/mode-regl.service';

import { ModeReglModel } from './../../../models/simple-types/modeRegl.model';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';

export interface DialogData {
        form: UntypedFormGroup;
        modeRegls: ModeReglModel[];
        result: boolean;
      }
@Component({
    selector: 'app-modal-add-mode-regl',
    templateUrl: './modal-add-mode-regl.component.html',
    styleUrls: ['./modal-add-mode-regl.component.scss']
  })
export class ModalAddModeReglComponent implements OnInit {

  modeRegls: ModeReglModel[];
  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<GestionModeReglComponent>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private router: Router
            , private modeReglService: ModeReglService) {
          }

  ngOnInit(): void {
    this.modeRegls = this.data.modeRegls;
    this.form = this.data.form;
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const modeRegl = this.form.getRawValue();
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.modeReglService.save(modeRegl).subscribe((a: ModeReglModel) => {
            this.toastr.success('', 'Création du mode de réglement ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.modeReglService.update(modeRegl.id, modeRegl).subscribe((a: ModeReglModel) => {
          this.toastr.success('', 'Modification du mode de réglement ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }

}


